
export interface Video {
  id: string;
  url: string;
  source: 'YouTube' | 'Hudl' | 'BallerTV' | 'Other';
  title?: string;
  description?: string;
  created_at: string;
}

export const VIDEO_SOURCES = ['YouTube', 'Hudl', 'BallerTV', 'Other'] as const;
